// test1992
(1992 && 0);
